import { addressFormOptions } from '@psl/flows/common/address/functions/addressFormOptions';
import { useMemo } from 'react';
import { WithID } from '../../../functions/firebase/rxfireExtensions';
import { useValidateFormData } from '../../../functions/ux/form/useForm';
import { PrivateProfile } from '../../../models/ClientModels';
import { AddressFormValue } from '../../common/address/components/AddressDetailForm';

export const useIsBusinessLocationValid = (
  privateProfile: WithID<PrivateProfile>,
) => {
  const addr = privateProfile?.sellerShippingAddress;
  const options = useMemo(() => addressFormOptions(), []);
  const validate = useValidateFormData<AddressFormValue>(options);
  return addr != null && validate(addr)[0];
};
